export const inventory = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  NavSidebar: {},
  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'inventory' })) } return false } })() },

  MainContent: {
    flow: 'y', flex: '1', overflow: 'auto',
    TopBar: {},
    ContentArea: {
      flow: 'y', gap: 'B', padding: 'B', flex: '1',

      InventoryNav: {
        flow: 'x', gap: 'Z', borderBottom: '1px solid inkBorder', paddingBottom: 'Y',
        TabStock: { text: '{{ stock | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', color: (el, s) => s.root.inventoryTab === 'stock' || !s.root.inventoryTab ? 'teal' : 'inkMuted', borderBottom: (el, s) => s.root.inventoryTab === 'stock' || !s.root.inventoryTab ? '2px solid teal' : '2px solid transparent', onClick: (e, el, s) => s.root.update({ inventoryTab: 'stock' }) },
        TabOrders: { text: '{{ orders | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', color: (el, s) => s.root.inventoryTab === 'orders' ? 'teal' : 'inkMuted', borderBottom: (el, s) => s.root.inventoryTab === 'orders' ? '2px solid teal' : '2px solid transparent', onClick: (e, el, s) => s.root.update({ inventoryTab: 'orders' }) },
        TabSuppliers: { text: '{{ suppliers | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', color: (el, s) => s.root.inventoryTab === 'suppliers' ? 'teal' : 'inkMuted', borderBottom: (el, s) => s.root.inventoryTab === 'suppliers' ? '2px solid teal' : '2px solid transparent', onClick: (e, el, s) => s.root.update({ inventoryTab: 'suppliers' }) },
        TabUsage: { text: '{{ usageLog | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', color: (el, s) => s.root.inventoryTab === 'usage' ? 'teal' : 'inkMuted', borderBottom: (el, s) => s.root.inventoryTab === 'usage' ? '2px solid teal' : '2px solid transparent', onClick: (e, el, s) => s.root.update({ inventoryTab: 'usage' }) }
      },

      // Stock View
      StockView: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.inventoryTab === 'stock' || !s.root.inventoryTab,

        StatsRow: {
          flow: 'x', gap: 'Z', flexWrap: 'wrap', marginBottom: 'Z',
          TotalItems: { extends: 'StatCard', state: { label: '{{ totalItems | polyglot }}', value: '142', delta: '+8' } },
          LowStockStat: { extends: 'StatCard', state: { label: '{{ lowStock | polyglot }}', value: '5', delta: '-2' } },
          PendingOrders: { extends: 'StatCard', state: { label: '{{ pendingOrders | polyglot }}', value: '3' } },
          MonthlySpend: { extends: 'StatCard', state: { label: '{{ monthlySpend | polyglot }}', value: '\u20BE4,280', delta: '+12%' } }
        },

        LowStockAlerts: {
          flow: 'y', gap: 'Z', marginBottom: 'A',
          AlertTitle: { text: '{{ lowStockAlerts | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'red' },
          AlertGrid: {
            display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'Z',
            children: [
              { name: 'Composite Resin A2', category: 'Restorative', quantity: 3, unit: 'syringes', reorderLevel: 5, maxCapacity: 30 },
              { name: 'Nitrile Gloves (M)', category: 'Disposables', quantity: 2, unit: 'boxes', reorderLevel: 5, maxCapacity: 20 },
              { name: 'Gutta Percha Points', category: 'Endodontic', quantity: 8, unit: 'packs', reorderLevel: 10, maxCapacity: 50 }
            ],
            childrenAs: 'state',
            childExtends: 'InventoryCard'
          }
        },

        CategoryFilter: {
          flow: 'x', gap: 'Y', flexWrap: 'wrap', paddingBottom: 'Z',
          AllPill: { tag: 'button', text: '{{ allFilter | polyglot }}', padding: 'Y Z', round: 'C', background: 'teal', color: 'ink', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none' },
          RestorativePill: { tag: 'button', text: '{{ restorative | polyglot }}', padding: 'Y Z', round: 'C', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none' },
          EndodonticPill: { tag: 'button', text: '{{ endodontic | polyglot }}', padding: 'Y Z', round: 'C', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none' },
          ProstheticPill: { tag: 'button', text: '{{ prosthetic | polyglot }}', padding: 'Y Z', round: 'C', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none' },
          SurgicalPill: { tag: 'button', text: '{{ surgical | polyglot }}', padding: 'Y Z', round: 'C', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none' },
          HygienePill: { tag: 'button', text: '{{ hygiene | polyglot }}', padding: 'Y Z', round: 'C', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none' },
          DisposablesPill: { tag: 'button', text: '{{ disposables | polyglot }}', padding: 'Y Z', round: 'C', background: 'inkSurface', color: 'inkMuted', fontSize: 'Y', fontWeight: '500', cursor: 'pointer', border: 'none' }
        },

        InventoryGrid: {
          display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'A',
          children: [
            { name: 'Composite Resin A2', category: 'Restorative', quantity: 3, unit: 'syringes', reorderLevel: 5, maxCapacity: 30 },
            { name: 'Ceramic Crowns (Premolar)', category: 'Prosthetic', quantity: 18, unit: 'units', reorderLevel: 8, maxCapacity: 40 },
            { name: 'Endodontic Files #25', category: 'Endodontic', quantity: 22, unit: 'packs', reorderLevel: 10, maxCapacity: 50 },
            { name: 'Surgical Sutures 4-0', category: 'Surgical', quantity: 14, unit: 'packs', reorderLevel: 6, maxCapacity: 30 },
            { name: 'Prophy Paste (Mint)', category: 'Hygiene', quantity: 25, unit: 'cups', reorderLevel: 10, maxCapacity: 60 },
            { name: 'Nitrile Gloves (M)', category: 'Disposables', quantity: 2, unit: 'boxes', reorderLevel: 5, maxCapacity: 20 },
            { name: 'Dental Adhesive', category: 'Restorative', quantity: 12, unit: 'bottles', reorderLevel: 4, maxCapacity: 20 },
            { name: 'Gutta Percha Points', category: 'Endodontic', quantity: 8, unit: 'packs', reorderLevel: 10, maxCapacity: 50 },
            { name: 'Impression Material (VPS)', category: 'Prosthetic', quantity: 15, unit: 'cartridges', reorderLevel: 6, maxCapacity: 30 },
            { name: 'Scalpel Blades #15', category: 'Surgical', quantity: 30, unit: 'blades', reorderLevel: 10, maxCapacity: 50 }
          ],
          childrenAs: 'state',
          childExtends: 'InventoryCard'
        }
      },

      // Orders View
      OrdersView: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.inventoryTab === 'orders',
        OrdersTitle: { text: '{{ pendingOrders | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
        OrdersList: {
          flow: 'y', gap: 'Z',
          Order1: {
            flow: 'y', gap: 'Y', padding: 'B', round: 'Z', background: 'inkMid', border: '1px solid inkBorder',
            TopRow: {
              flow: 'x', justifyContent: 'space-between', align: 'center flex-start',
              OrderId: { text: 'ORD-2026-041', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
              Status: { tag: 'span', text: '{{ shipped | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'blue.15', color: 'blue' }
            },
            Supplier: { text: 'DentSupply Georgia', fontSize: 'Y', color: 'inkMuted' },
            Items: { text: 'Composite Resin A2 x20, Dental Adhesive x10', fontSize: 'Y', color: 'inkText' },
            DateRow: {
              flow: 'x', gap: 'A',
              Ordered: { text: '{{ ordered | polyglot }}: Mar 15, 2026', fontSize: 'Y', color: 'inkMuted' },
              ETA: { text: 'ETA: Mar 21, 2026', fontSize: 'Y', fontWeight: '600', color: 'teal' }
            }
          },
          Order2: {
            flow: 'y', gap: 'Y', padding: 'B', round: 'Z', background: 'inkMid', border: '1px solid inkBorder',
            TopRow: {
              flow: 'x', justifyContent: 'space-between', align: 'center flex-start',
              OrderId: { text: 'ORD-2026-042', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
              Status: { tag: 'span', text: '{{ processing | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'amber.15', color: 'amber' }
            },
            Supplier: { text: 'MedGeo Supplies', fontSize: 'Y', color: 'inkMuted' },
            Items: { text: 'Nitrile Gloves (M) x10, Scalpel Blades #15 x5', fontSize: 'Y', color: 'inkText' },
            DateRow: {
              flow: 'x', gap: 'A',
              Ordered: { text: '{{ ordered | polyglot }}: Mar 17, 2026', fontSize: 'Y', color: 'inkMuted' },
              ETA: { text: 'ETA: Mar 24, 2026', fontSize: 'Y', fontWeight: '600', color: 'teal' }
            }
          },
          Order3: {
            flow: 'y', gap: 'Y', padding: 'B', round: 'Z', background: 'inkMid', border: '1px solid inkBorder',
            TopRow: {
              flow: 'x', justifyContent: 'space-between', align: 'center flex-start',
              OrderId: { text: 'ORD-2026-043', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
              Status: { tag: 'span', text: '{{ confirmed | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'green.15', color: 'green' }
            },
            Supplier: { text: 'Caucasus Dental Co.', fontSize: 'Y', color: 'inkMuted' },
            Items: { text: 'Gutta Percha Points x15, Endodontic Files #25 x10', fontSize: 'Y', color: 'inkText' },
            DateRow: {
              flow: 'x', gap: 'A',
              Ordered: { text: '{{ ordered | polyglot }}: Mar 18, 2026', fontSize: 'Y', color: 'inkMuted' },
              ETA: { text: 'ETA: Mar 25, 2026', fontSize: 'Y', fontWeight: '600', color: 'teal' }
            }
          }
        }
      },

      // Suppliers View
      SuppliersView: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.inventoryTab === 'suppliers',
        SuppliersTitle: { text: '{{ suppliers | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
        SuppliersGrid: {
          display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 'A',
          children: [
            { name: 'DentSupply Georgia', contact: 'Giorgi Kharadze', phone: '+995 577 123 456', deliveryAvailable: true, rating: 5, estimatedDays: 3, minimumOrder: '\u20BE200' },
            { name: 'MedGeo Supplies', contact: 'Nino Avaliani', phone: '+995 599 234 567', deliveryAvailable: true, rating: 4, estimatedDays: 5, minimumOrder: '\u20BE150' },
            { name: 'Caucasus Dental Co.', contact: 'Davit Topuria', phone: '+995 571 345 678', deliveryAvailable: true, rating: 4, estimatedDays: 4, minimumOrder: '\u20BE300' },
            { name: 'EuroDent Import', contact: 'Ana Merabishvili', phone: '+995 555 456 789', deliveryAvailable: false, rating: 3, estimatedDays: 14, minimumOrder: '\u20BE500' }
          ],
          childrenAs: 'state',
          childExtends: 'SupplierCard'
        }
      },

      // Usage Log View
      UsageView: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.inventoryTab === 'usage',
        UsageTitle: { text: '{{ usageLog | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
        UsageSubtitle: { text: '{{ recentMaterialUsage | polyglot }}', fontSize: 'Z', color: 'inkMuted', marginBottom: 'Z' },
        UsageList: {
          flow: 'y', gap: 'Z',
          children: [
            { materialName: 'Composite Resin A2', quantityUsed: 2, unit: 'syringes' },
            { materialName: 'Dental Adhesive', quantityUsed: 1, unit: 'bottle' },
            { materialName: 'Nitrile Gloves (M)', quantityUsed: 4, unit: 'pairs' },
            { materialName: 'Prophy Paste (Mint)', quantityUsed: 3, unit: 'cups' },
            { materialName: 'Surgical Sutures 4-0', quantityUsed: 1, unit: 'pack' },
            { materialName: 'Endodontic Files #25', quantityUsed: 2, unit: 'packs' },
            { materialName: 'Impression Material (VPS)', quantityUsed: 2, unit: 'cartridges' },
            { materialName: 'Scalpel Blades #15', quantityUsed: 3, unit: 'blades' }
          ],
          childrenAs: 'state',
          childExtends: 'MaterialUsageRow'
        }
      }
    },
    MobileTabBar: {}
  }
}
